import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NotificationListModule } from '@portal-core/notifications/components/notification-list/notification-list.module';
import { UserNotificationListComponent } from './user-notification-list.component';

@NgModule({
  declarations: [
    UserNotificationListComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressBarModule,
    NotificationListModule
  ],
  exports: [
    UserNotificationListComponent
  ]
})
export class UserNotificationListModule { }
